<template>
  <div class="loading" v-if="loading">
    <loading />
  </div>
  <pie-chart v-else width="auto" height="300px" :series-data="series" :tooltip-formater="tooltipRender" tooltip-class="order-pie-tooltip" />
</template>
<script>
import PieChart from '@/components/PieChart.vue'
import Loading from '@/components/Loading.vue'
import { brandGroupDict, LoadBrandStatistic } from '../services'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'CustomerGaugeChart',
  props: {
    timeSpan: {
      type: Array,
      default () {
        return null
      }
    }
  },
  components: { PieChart, Loading },
  data () {
    return {
      loading: true,
      series: []
    }
  },
  computed: {
    startDay () {
      if (this.timeSpan) {
        return moment(this.timeSpan[0]).format('YYYY-MM-DD')
      }
      return undefined
    },
    endDay () {
      if (this.timeSpan) {
        return moment(this.timeSpan[1]).format('YYYY-MM-DD')
      }
      return undefined
    }
  },
  watch: {
    startDay () {
      this.loadDataDebounce()
    },
    endDay () {
      this.loadDataDebounce()
    },
    newAdd () {
      this.loadDataDebounce()
    },
    area () {
      this.loadDataDebounce()
    }
  },
  created () {
    this.loadDataDebounce = _.debounce(() => {
      this.loadData()
    }, 30)
  },
  mounted () {
    this.loadDataDebounce()
  },
  methods: {
    loadData () {
      this.loading = true
      LoadBrandStatistic({ newAdd: this.newAdd, area: this.area || undefined, startDay: this.startDay, endDay: this.endDay }).then(resp => {
        this.series = resp
      }).finally(() => {
        this.loading = false
      })
    },
    tooltipRender (params, ticket) {
      return `
<div>
  <div class="date">${brandGroupDict[params.name]}</div>
  <div class="serie-item">
    <div style="--serie-color:${params.color}">
      <div class="serie-color-block"></div>
    </div>
    <div>消费</div>
    <div>${params.data.amount}</div>
  </div>
  <div class="serie-item">
    <div style="--serie-color:${params.color}">
      <div class="serie-color-block"></div>
    </div>
    <div>退款</div>
    <div>${params.data.amountReturn}</div>
  </div>
  <div class="serie-item">
    <div style="--serie-color:${params.color}">
      <div class="serie-color-block"></div>
    </div>
    <div>总计</div>
    <div>${params.value}</div>
  </div>
  <div class="serie-item">
    <div style="--serie-color:${params.color}">
      <div class="serie-color-block"></div>
    </div>
    <div>占比</div>
    <div>${params.percent}%</div>
  </div>
</div>
      `
    }
  }
}
</script>
